/**
 * Emits line from point in a given angle and returns the end point
 */
export function getLineEnd({ x: startX, y: startY }, { angle, length }) {
  const x = startX + Math.cos(angle) * length;
  const y = startY - Math.sin(angle) * length;
  return { x, y };
}
